module.exports = __webpack_public_path__ + "img/star_border.d91baf8d.svg";